import config from '../../../../../config';
import Request from '../../../../Request';

export default function create(itemId, itemBookableDurationId, values, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/items/${itemId}/item_bookable_durations/${itemBookableDurationId}/item_availabilities`,
  { item_availability: values },
                     onSuccess,
                     onFailure
                    );
}